import React from 'react';
import { MediaPlaceholder } from './MediaPlaceholder';
import { CtaButton } from './CtaButton';
import { ShieldCheck, Lock, CreditCard, Users, Zap } from 'lucide-react';
const badges = [{
  icon: ShieldCheck,
  label: 'Garantía 7 días'
}, {
  icon: Lock,
  label: 'Pago seguro'
}, {
  icon: CreditCard,
  label: 'Mercado Pago'
}, {
  icon: Users,
  label: '+3.597 Alumnas'
}, {
  icon: Zap,
  label: 'Acceso en 5 minutos'
}];
export function HeroSection() {
  return <section className="px-6 pt-6 pb-12 flex flex-col items-center text-center relative z-10 max-w-7xl mx-auto" data-id="element-74">
      {/* Students proof image (stars + avatars) */}

      {/* Hero Title */}
      <div className="w-full mb-10 max-w-5xl flex flex-col items-center" data-id="element-75">
        {/* Discount Badge */}
        <div className="text-white font-black text-[10px] md:text-sm px-6 py-2 rounded-full mb-8 shadow-[0_0_15px_rgba(34,197,94,0.6)] border border-green-400/30 uppercase tracking-widest bg-[#D98BAF]" data-id="element-76">
          50% OFF - CUPOS LIMITADOS
        </div>

        <h1 className="text-brand-navy font-black mb-6 tracking-tight uppercase text-[30px]" style={{
        fontFamily: "'Inter', sans-serif",
        fontWeight: 900
      }} data-id="element-77">
          APRENDÉ A CREAR{' '}
          <span className="text-[#D98BAF] underline decoration-[#D98BAF] underline-offset-4" data-id="element-78">
            VIDEOS UGC
          </span>{' '}
          Y TRABAJA CON LAS MARCAS{' '}
          <span className="text-[#D98BAF] underline decoration-[#D98BAF] underline-offset-4" data-id="element-79">
            DESDE CASA
          </span>
          💸
        </h1>

        <p className="text-lg md:text-2xl uppercase tracking-tight font-[700] font-[Montserrat,_sans-serif] text-[#D98BAF]" data-id="element-80">
          ✨Sin experiencia ni seguidores. ✨Desde cero, Con consultorías y
          acompañamiento 💻
        </p>
      </div>

      {/* Initial Video */}
      <div className="w-full mb-8 relative max-w-5xl" data-id="element-81">
        <div className="absolute -inset-2 bg-gradient-to-tr from-brand-pink to-brand-lavender rounded-3xl blur-lg opacity-50" data-id="element-82"></div>
        <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-xl bg-black z-10" data-id="element-83">
          <iframe src="https://player.vimeo.com/video/1200659338?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" className="absolute top-0 left-0 w-full h-full" title="formula_creadora_de_contenido_ugc_v3 (1080p)" data-id="element-84"></iframe>
        </div>
      </div>

      {/* Copy */}
      <p className="text-brand-navy font-medium md:text-3xl mb-6 px-1 max-w-4xl text-[16px]" data-id="element-85">
        Con mi método paso a paso, dejá de improvisar y empezá a cobrar +$150
        usd por cada video UGC como una Creadora PRO💸✨
      </p>

      {/* Students count */}
      <p className="text-brand-navy font-semibold mb-6 md:text-2xl" data-id="element-86">
        +3.597 Alumnas UGC ⭐⭐⭐⭐⭐
      </p>

      {/* CTA */}
      <div className="md:scale-125 md:my-8" data-id="element-87">
        <CtaButton variant="gold" data-id="element-88">¡SI, QUIERO INSCRIBIRME!</CtaButton>
      </div>

      {/* Trust badges */}
      <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-12 gap-y-2 mt-5 px-2" data-id="element-89">
        <span className="text-[12px] md:text-base font-medium text-brand-navy/80 text-center leading-relaxed" data-id="element-90">
          🛡️ Garantía 7 días 🔒 Pago seguro 💳 Mercado Pago ⭐+357 Alumnas
          ⚡Acceso en 5 minutos
        </span>
      </div>
    </section>;
}